import type { AiWorkspaceCardData } from '@/composables/useAiChat';

/**
 * Card types whose job is a person's accept / decline. The floating chat
 * repeats them inline above the composer so the decision doesn't hide behind
 * the Workspace tab; the full card stays in the workspace for the details.
 */
export const INLINE_DECISION_CARD_TYPES = ['action_confirmation'] as const;

/** At most this many decisions sit above the composer (newest first). */
export const MAX_INLINE_DECISIONS = 3;

export interface InlineDecision {
  cardId: string;
  pendingActionId: string;
}

function pendingActionIdOf(card: AiWorkspaceCardData): string | null {
  const p = card.props ?? {};
  const raw = p.pendingActionId ?? p.pending_action_id ?? p.id;
  return typeof raw === 'string' && raw !== '' ? raw : null;
}

/** The decision cards among the workspace cards, newest first, capped. */
export function inlineDecisions(cards: AiWorkspaceCardData[]): InlineDecision[] {
  const out: InlineDecision[] = [];
  for (const card of cards) {
    if (!(INLINE_DECISION_CARD_TYPES as readonly string[]).includes(card.type)) continue;
    const pendingActionId = pendingActionIdOf(card);
    if (pendingActionId === null) continue;
    out.push({ cardId: card.id, pendingActionId });
    if (out.length >= MAX_INLINE_DECISIONS) break;
  }
  return out;
}
